/**
 * Battery Calculator Page
 * NFPA 72 Battery Capacity Calculator
 */

import BatteryCalculator from '../components/calculators/BatteryCalculator';
import CalculatorErrorBoundary from '../components/CalculatorErrorBoundary';

export default function BatteryCalculatorPage() {
  return (
    <CalculatorErrorBoundary calculatorName="Battery Calculator">
      <BatteryCalculator />
    </CalculatorErrorBoundary>
  );
}
